module.exports = __webpack_public_path__ + "img/Miteinander.47cd2739.jpg";